import { Response } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { ajaxSend } from 'api/api';

const v1Path = '/v1/users/agents';

type AgentsQueryParams = Partial<{
  search: string;
  offset: number;
  limit: number;
  sort_by: string;
}>;

export interface AgentsResponseData {
  number_of_agents: number;
  agents: User[];
}

type GetAgentOptions = Partial<{
  params: AgentsQueryParams;
  path: string;
}>;
export function getAgents({
  params = {},
  path = v1Path,
}: GetAgentOptions): Promise<Response<AgentsResponseData>> {
  return ajaxSend({
    path,
    params,
  });
}
